import { Link, useLocation } from "react-router-dom";
import { Linkedin, Mail } from "lucide-react";

const EMAIL = "hello@kalzastudio.com";

export const Footer = () => {
  const location = useLocation();
  const isPL = location.pathname.startsWith("/pl");
  const currentYear = new Date().getFullYear();

  const workLinks = isPL ? [
    { to: "/pl/sprint", label: "Brand Reality Check Audit" },
    { to: "/pl/brand-foundation", label: "Brand Foundation" },
    { to: "/pl/visual-identity", label: "Full Brand System" },
    { to: "/pl/consultation", label: "Konsultacja 1:1" },
    { to: "/pl/ai-products", label: "Produkty AI" },
  ] : [
    { to: "/sprint", label: "Brand Reality Check Audit" },
    { to: "/brand-foundation", label: "Brand Foundation" },
    { to: "/visual-identity", label: "Full Brand System" },
    { to: "/consultation", label: "1:1 Consultation" },
    { to: "/ai-products", label: "AI Products" },
  ];

  const companyLinks = isPL ? [
    { to: "/pl/about", label: "O mnie" },
    { to: "/pl/services", label: "Usługi" },
    { to: "/pl/contact", label: "Kontakt" },
  ] : [
    { to: "/about", label: "About" },
    { to: "/services", label: "All Services" },
    { to: "/faq", label: "FAQ" },
    { to: "/contact", label: "Contact" },
  ];

  const tagline = isPL
    ? "Jasność, której potrzebują założyciele, żeby odblokować swój biznes."
    : "The clarity founders need to finally move their business.";

  const description = isPL
    ? "Zmieniam marki, które utknęły, w żywe biznesy. Daję założycielom jasność, po której wraca im energia do działania. Przestają zgadywać, zaczynają decydować i znów czują, że to jest ich biznes."
    : "I turn stalled businesses into living brands. I give founders the clarity that unlocks their energy, so they stop guessing, start deciding and fall back in love with their own business.";

  const workTitle = isPL ? "WSPÓŁPRACA" : "WORK WITH ME";
  const companyTitle = isPL ? "FIRMA" : "COMPANY";

  return (
    <footer className="bg-[#f5f5f7] border-t border-[#E8E3DE]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          <div className="md:col-span-2">
            <Link to={isPL ? "/pl" : "/"} className="inline-block">
              <img src="/images/logo-dark.svg" alt="KALZA Studio" className="h-10 w-auto" />
            </Link>
            <p className="font-accent text-lg text-[#6B6560] mt-4 max-w-sm">"{tagline}"</p>
            <p className="font-body text-sm text-[#6B6560] mt-4 max-w-sm leading-relaxed">
              {description}
            </p>
            <div className="flex gap-4 mt-6">
              <a href="https://www.linkedin.com/in/aleksandrakaluza/" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white text-[#6B6560] hover:text-[#BE123C] transition-colors duration-300">
                <Linkedin size={18} />
              </a>
              <a href={`mailto:${EMAIL}`} className="p-2 rounded-full bg-white text-[#6B6560] hover:text-[#BE123C] transition-colors duration-300">
                <Mail size={18} />
              </a>
            </div>
            <p className="font-body text-xs text-[#6B6560]/70 mt-4">{EMAIL}</p>
          </div>

          <div>
            <h4 className="font-eyebrow text-[#1C1210] mb-4">{workTitle}</h4>
            <ul className="space-y-3">
              {workLinks.map((link, i) => (
                <li key={i}>
                  <Link to={link.to} className="font-body text-sm text-[#6B6560] hover:text-[#BE123C] transition-colors duration-300">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-eyebrow text-[#1C1210] mb-4">{companyTitle}</h4>
            <ul className="space-y-3">
              {companyLinks.map((link, i) => (
                <li key={i}>
                  <Link to={link.to} className="font-body text-sm text-[#6B6560] hover:text-[#BE123C] transition-colors duration-300">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#E8E3DE]">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-body text-sm text-[#6B6560]/60">© {currentYear} KALZA Studio. All rights reserved.</p>
            <p className="font-body text-xs text-[#6B6560]/40">Crafted with light and intention</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
